// extracted by mini-css-extract-plugin
export var figcaption = "TeamMember-module--figcaption--2577e";
export var figure = "TeamMember-module--figure--42d3b";
export var imgLink = "TeamMember-module--img-link--0ddcd";
export var lgxVertical = "TeamMember-module--lgx-vertical--58140";
export var nameHover = "TeamMember-module--name-hover--48eab";
export var teamMember = "TeamMember-module--team-member--5312b";